import { Button, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

const SideBar = ({ bank }) => {
  const navigate = useNavigate();
  const buttonStyle = {
    fontSize: 15,
    fontWeight: 500,
    lineHeight: "20px",
    color: "#8A8A8A",
    letterSpacing: "0.08px",
    fontFamily: "'Archivo',sans-serif",
    textTransform: "none",
    textAlign: "start",
    backgroundColor: "#ffffff",
  };
  return (
    <>
      <div
        id="others_emi_links"
        style={{
          width: "100%",
          border: " 1px solid gray",
          borderRadius: "5px",
          padding: "10px",
          backgroundColor: "#ffffff",
        }}
      >
        <div>
          <div className="mt-3">
            <Typography
              sx={{
                fontSize: 16,
                lineHeight: "20px",
                letterSpacing: "0.08px",
                fontWeight: 700,
                color: "#1f1f1f",
                fontFamily: "'Archivo',sans-serif",
              }}
              className="mb-3"
            >
              More EMI Calculators
            </Typography>

            <div className="line border-top my-1"></div>
          </div>
          <div className="d-flex flex-column">
            <div>
              <div className={`${bank === "pl" && "d-none"}`}>
                <Button
                  sx={buttonStyle}
                  onClick={() => {
                    navigate(
                      "/calculators/emi-calculators/personal-loan-emi-calculator"
                    );
                  }}
                >
                  Personal Loan EMI Calculator
                </Button>
                <div className="line border-top my-1"></div>
              </div>
              <div className={`${bank === "hl" && "d-none"}`}>
                <Button
                  sx={buttonStyle}
                  onClick={() => {
                    navigate(
                      "/calculators/emi-calculators/home-loan-emi-calculator"
                    );
                  }}
                >
                  Home Loan EMI Calculator
                </Button>
                <div className="line border-top my-1"></div>
              </div>
              <div className={`${bank === "cl" && "d-none"}`}>
                <Button
                  sx={buttonStyle}
                  onClick={() => {
                    navigate(
                      "/calculators/emi-calculators/car-loan-emi-calculator"
                    );
                  }}
                >
                  Car Loan EMI Calculator
                </Button>
                <div className="line border-top my-1"></div>
              </div>

              <div className={`${bank === "ccl" && "d-none"}`}>
                <Button
                  sx={buttonStyle}
                  onClick={() => {
                    navigate(
                      "/calculators/emi-calculators/credit-card-loan-emi-calculator"
                    );
                  }}
                >
                  Credit Card Loan EMI Calculator
                </Button>
                <div className="line border-top my-1"></div>
              </div>

              <div className={`${bank === "sbipl" && "d-none"}`}>
                <Button
                  sx={buttonStyle}
                  onClick={() => {
                    navigate(
                      "/calculators/emi-calculators/sbi-personal-loan-emi-calculator"
                    );
                  }}
                >
                  SBI Personal Loan EMI Calculator
                </Button>
                <div className="line border-top my-1"></div>
              </div>

              <div className={`${bank === "sbihl" && "d-none"}`}>
                <Button
                  sx={buttonStyle}
                  onClick={() => {
                    navigate(
                      "/calculators/emi-calculators/sbi-home-loan-emi-calculator"
                    );
                  }}
                >
                  SBI Home Loan EMI Calculator
                </Button>
                <div className="line border-top my-1"></div>
              </div>

              <div className={`${bank === "sbicl" && "d-none"}`}>
                <Button
                  sx={buttonStyle}
                  onClick={() => {
                    navigate(
                      "/calculators/emi-calculators/sbi-car-loan-emi-calculator"
                    );
                  }}
                >
                  SBI Car Loan EMI Calculator
                </Button>
                <div className="line border-top my-1"></div>
              </div>

              <div className={`${bank === "axispl" && "d-none"}`}>
                <Button
                  sx={buttonStyle}
                  onClick={() => {
                    navigate(
                      "/calculators/emi-calculators/axis-bank-personal-loan-emi-calculator"
                    );
                  }}
                >
                  Axis Bank Personal Loan EMI Calculator
                </Button>
                <div className="line border-top my-1"></div>
              </div>

              <div className={`${bank === "axishl" && "d-none"}`}>
                <Button
                  sx={buttonStyle}
                  onClick={() => {
                    navigate(
                      "/calculators/emi-calculators/axis-bank-home-loan-emi-calculator"
                    );
                  }}
                >
                  Axis Bank Home Loan EMI Calculator
                </Button>
                <div className="line border-top my-1"></div>
              </div>

              <div className={`${bank === "axiscl" && "d-none"}`}>
                <Button
                  sx={buttonStyle}
                  onClick={() => {
                    navigate(
                      "/calculators/emi-calculators/axis-bank-car-loan-emi-calculator"
                    );
                  }}
                >
                  Axis Bank Car Loan EMI Calculator
                </Button>
                <div className="line border-top my-1"></div>
              </div>

              <div className={`${bank === "hdfcpl" && "d-none"}`}>
                <Button
                  sx={buttonStyle}
                  onClick={() => {
                    navigate(
                      "/calculators/emi-calculators/hdfc-personal-loan-emi-calculator"
                    );
                  }}
                >
                  HDFC Personal Loan EMI Calculator
                </Button>
                <div className="line border-top my-1"></div>
              </div>

              <div className={`${bank === "hdfchl" && "d-none"}`}>
                <Button
                  sx={buttonStyle}
                  onClick={() => {
                    navigate(
                      "/calculators/emi-calculators/hdfc-home-loan-emi-calculator"
                    );
                  }}
                >
                  HDFC Home Loan EMI Calculator
                </Button>
                <div className="line border-top my-1"></div>
              </div>

              <div className={`${bank === "hdfccl" && "d-none"}`}>
                <Button
                  sx={buttonStyle}
                  onClick={() => {
                    navigate(
                      "/calculators/emi-calculators/hdfc-car-loan-emi-calculator"
                    );
                  }}
                >
                  HDFC Car Loan EMI Calculator
                </Button>
                <div className="line border-top my-1"></div>
              </div>

              <div className={`${bank === "icicipl" && "d-none"}`}>
                <Button
                  sx={buttonStyle}
                  onClick={() => {
                    navigate(
                      "/calculators/emi-calculators/icici-personal-loan-emi-calculator"
                    );
                  }}
                >
                  ICICI Personal Loan EMI Calculator
                </Button>
                <div className="line border-top my-1"></div>
              </div>

              <div className={`${bank === "icicihl" && "d-none"}`}>
                <Button
                  sx={buttonStyle}
                  onClick={() => {
                    navigate(
                      "/calculators/emi-calculators/icici-home-loan-emi-calculator"
                    );
                  }}
                >
                  ICICI Home Loan EMI Calculator
                </Button>
                <div className="line border-top my-1"></div>
              </div>

              <div className={`${bank === "icicicl" && "d-none"}`}>
                <Button
                  sx={buttonStyle}
                  onClick={() => {
                    navigate(
                      "/calculators/emi-calculators/icici-car-loan-emi-calculator"
                    );
                  }}
                >
                  ICICI Car Loan EMI Calculator
                </Button>
                <div className="line border-top my-1"></div>
              </div>

              <div className={`${bank === "kotakpl" && "d-none"}`}>
                <Button
                  sx={buttonStyle}
                  onClick={() => {
                    navigate(
                      "/calculators/emi-calculators/kotak-mahindra-personal-loan-emi-calculator"
                    );
                  }}
                >
                  Kotak Mahindra Bank Personal Loan EMI Calculator
                </Button>
                <div className="line border-top my-1"></div>
              </div>

              <div className={`${bank === "kotakhl" && "d-none"}`}>
                <Button
                  sx={buttonStyle}
                  onClick={() => {
                    navigate(
                      "/calculators/emi-calculators/kotak-mahindra-home-loan-emi-calculator"
                    );
                  }}
                >
                  Kotak Mahindra Bank Home Loan EMI Calculator
                </Button>
                <div className="line border-top my-1"></div>
              </div>

              <div className={`${bank === "kotakcl" && "d-none"}`}>
                <Button
                  sx={buttonStyle}
                  onClick={() => {
                    navigate(
                      "/calculators/emi-calculators/kotak-mahindra-car-loan-emi-calculator"
                    );
                  }}
                >
                  Kotak Mahindra Bank Car Loan EMI Calculator
                </Button>

                <div className="line border-top my-1"></div>
              </div>

              <div className={`${bank === "indianpl" && "d-none"}`}>
                <Button
                  sx={buttonStyle}
                  onClick={() => {
                    navigate(
                      "/calculators/emi-calculators/indian-overseas-bank-personal-loan-emi-calculator"
                    );
                  }}
                >
                  Indian Overseas Bank Personal Loan EMI Calculator
                </Button>
                <div className="line border-top my-1"></div>
              </div>

              <div className={`${bank === "indianhl" && "d-none"}`}>
                <Button
                  sx={buttonStyle}
                  onClick={() => {
                    navigate(
                      "/calculators/emi-calculators/indian-overseas-bank-home-loan-emi-calculator"
                    );
                  }}
                >
                  Indian Overseas Bank Home Loan EMI Calculator
                </Button>
                <div className="line border-top my-1"></div>
              </div>

              <div className={`${bank === "barodapl" && "d-none"}`}>
                <Button
                  sx={buttonStyle}
                  onClick={() => {
                    navigate(
                      "/calculators/emi-calculators/bank-of-baroda-personal-loan-emi-calculator"
                    );
                  }}
                >
                  Bank of Baroda Personal Loan EMI Calculator
                </Button>
                <div className="line border-top my-1"></div>
              </div>

              <div className={`${bank === "barodahl" && "d-none"}`}>
                <Button
                  sx={buttonStyle}
                  onClick={() => {
                    navigate(
                      "/calculators/emi-calculators/bank-of-baroda-home-loan-emi-calculator"
                    );
                  }}
                >
                  Bank of Baroda Home Loan EMI Calculator
                </Button>
                <div className="line border-top my-1"></div>
              </div>

              <div className={`${bank === "barodacl" && "d-none"}`}>
                <Button
                  sx={buttonStyle}
                  onClick={() => {
                    navigate(
                      "/calculators/emi-calculators/bank-of-baroda-car-loan-emi-calculator"
                    );
                  }}
                >
                  Bank of Baroda Car Loan EMI Calculator
                </Button>
                <div className="line border-top my-1"></div>
              </div>

              <div className={`${bank === "indusindpl" && "d-none"}`}>
                <Button
                  sx={buttonStyle}
                  onClick={() => {
                    navigate(
                      "/calculators/emi-calculators/indusind-bank-personal-loan-emi-calculator"
                    );
                  }}
                >
                  IndusInd Bank Personal Loan EMI Calculator
                </Button>
                <div className="line border-top my-1"></div>
              </div>

              <div className={`${bank === "indusindbl" && "d-none"}`}>
                <Button
                  sx={buttonStyle}
                  onClick={() => {
                    navigate(
                      "/calculators/emi-calculators/indusind-bank-home-loan-emi-calculator"
                    );
                  }}
                >
                  IndusInd Bank Home Loan EMI Calculator
                </Button>
                <div className="line border-top my-1"></div>
              </div>

              <div className={`${bank === "indusindcl" && "d-none"}`}>
                <Button
                  sx={buttonStyle}
                  onClick={() => {
                    navigate(
                      "/calculators/emi-calculators/indusind-bank-car-loan-emi-calculator"
                    );
                  }}
                >
                  IndusInd Bank Car Loan EMI Calculator
                </Button>
                <div className="line border-top my-1"></div>
              </div>

              <div className={`${bank === "canarapl" && "d-none"}`}>
                <Button
                  sx={buttonStyle}
                  onClick={() => {
                    navigate(
                      "/calculators/emi-calculators/canara-bank-personal-loan-emi-calculator"
                    );
                  }}
                >
                  Canara Bank Personal Loan EMI Calculator
                </Button>
                <div className="line border-top my-1"></div>
              </div>

              <div className={`${bank === "canarahl" && "d-none"}`}>
                <Button
                  sx={buttonStyle}
                  onClick={() => {
                    navigate(
                      "/calculators/emi-calculators/canara-bank-home-loan-emi-calculator"
                    );
                  }}
                >
                  Canara Bank Home Loan EMI Calculator
                </Button>
                <div className="line border-top my-1"></div>
              </div>

              <div className={`${bank === "canaracl" && "d-none"}`}>
                <Button
                  sx={buttonStyle}
                  onClick={() => {
                    navigate(
                      "/calculators/emi-calculators/canara-bank-car-loan-emi-calculator"
                    );
                  }}
                >
                  Canara Bank Car Loan EMI Calculator
                </Button>
                <div className="line border-top my-1"></div>
              </div>

              <div className={`${bank === "punjabpl" && "d-none"}`}>
                <Button
                  sx={buttonStyle}
                  onClick={() => {
                    navigate(
                      "/calculators/emi-calculators/punjab-national-bank-personal-loan-emi-calculator"
                    );
                  }}
                >
                  Punjab National Bank Personal Loan EMI Calculator
                </Button>
                <div className="line border-top my-1"></div>
              </div>

              <div className={`${bank === "punjabhl" && "d-none"}`}>
                <Button
                  sx={buttonStyle}
                  onClick={() => {
                    navigate(
                      "/calculators/emi-calculators/punjab-national-bank-home-loan-emi-calculator"
                    );
                  }}
                >
                  Punjab National Bank Home Loan EMI Calculator
                </Button>
                <div className="line border-top my-1"></div>
              </div>

              <div className={`${bank === "punjabcl" && "d-none"}`}>
                <Button
                  sx={buttonStyle}
                  onClick={() => {
                    navigate(
                      "/calculators/emi-calculators/punjab-national-bank-car-loan-emi-calculator"
                    );
                  }}
                >
                  Punjab National Bank Car Loan EMI Calculator
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SideBar;
